import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import PageHeader from "../../core/common/commonComponents/PageHeader";
import { exportToCSV, exportToExcel, exportToPDF } from "../../core/common/GlobalFunctions/exportTableData";
import StatusFilterHeader from "../../core/common/commonComponents/StatusFilterHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import PfEmployeeMappingModal from "./modals/PfEmployeeMappingModal";
import { deletePfEmployee, fetchAllPfEmployees } from "../../core/data/redux/payroll/Accounting/providentFund/pfEmployee/pfEmployeeActions";

const PfEmployeeMapping = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedStatus, setSelectedStatus] = useState('active');
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [tableKey, setTableKey] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { records } = useSelector((state: any) => state.providentFund.pfEmployeeMapping);

    const showModal = (type: 'edit' | 'create') => {
        setModalType(type);
        setIsModalVisible(true);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
        setModalType('');
    };

    useEffect(() => {
        if (!records.length) {
            dispatch(fetchAllPfEmployees())
        }
    }, [dispatch, records.length])

const filtereddata = useMemo(() => {
  const filters =
    selectedStatus && selectedStatus !== "All"
      ? { status: selectedStatus }
      : {};
  return filterData(records, filters, "createdAt", "createdAt", selectedSort);

  
}, [records, selectedStatus, selectedSort]);

const ExportData=  filtereddata?.map((item: any) => ({
    employeeName: item.employeeName || "N/A",
    UAN: item.UAN || "N/A",
    pfAccountNumber: item.pfAccountNumber || "N/A",
    nomineeName: item.nomineeName || "N/A",
    nomineeRelation: item.nomineeRelation || "N/A",
    createdAt: item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-IN") : "N/A",
    modifiedAt: item.modifiedAt ? new Date(item.modifiedAt).toLocaleDateString("en-IN") : "N/A",
    status: item.status || "Inactive",
    policyName: item.policyName || "N/A",
  }));

useEffect(() => {
        setTableKey(prevKey => prevKey + 1);
    }, [selectedStatus, selectedSort, records]);

    const handleDeletePfEmployee = async (id: number) => {
        try {
            const result = await dispatch(deletePfEmployee(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success('Employee Mapping deleted successfully');
                setTableKey((prevKey: any) => prevKey + 1);
                setTableKey((prevKey) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.error((result.payload as { error: string })?.error);
            }
        } catch (error) {
            message.error('Something went wrong');
        }
    };

    const columns = [
        {
            title: "Employee",
            dataIndex: "employeeName",
            render: (_: any, record: any) => (
                <div style={{ width: '220px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <img
                        src={record.employeePictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                        alt={record.employeeName}
                        style={{ width: 32, height: 32, borderRadius: "50%", marginRight: 8 }}
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = "/default-avatar.png";
                        }}
                    />
                    <span>{record.employeeName}</span>
                </div>
            ),
            sorter: (a: any, b: any) => a.employeeName?.localeCompare(b.employeeName),
        },
        {
            title: "Policy Name",
            dataIndex: "policyName", // Similarly, this could come from a policy lookup
            sorter: (a: any, b: any) => a.policyName?.localeCompare(b.policyName),
        },
        {
            title: "UAN",
            dataIndex: "UAN",
            sorter: (a: any, b: any) => a.UAN?.localeCompare(b.UAN),
        },
        {
            title: "Account Number",
            dataIndex: "pfAccountNumber",
            sorter: (a: any, b: any) => a.pfAccountNumber?.localeCompare(b.pfAccountNumber),
        },
        {
            title: "Nominee Name",
            dataIndex: "nomineeName",
            sorter: (a: any, b: any) => a.nomineeName?.localeCompare(b.nomineeName),
        },
        {
            title: "Nominee Relation",
            dataIndex: "nomineeRelation",
            sorter: (a: any, b: any) => a.nomineeRelation?.localeCompare(b.nomineeRelation),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string) => (
                <span
                    className={`badge ${text === "active" ? "badge-success" : "badge-danger"
                        } d-inline-flex align-items-center badge-xs`}
                >
                    <i className="ti ti-point-filled me-1" />
                    {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

                </span>
            ),
            filters: [
                { text: "Active", value: "active" },
                { text: "Inactive", value: "inactive" },
            ],
            onFilter: (value: string, record: any) => record.status === value,
        },
        {
            title: "Action",
            dataIndex: "actions",
            render: (_: any, record: any) => (
                <div className="action-icon d-inline-flex">
                    <button
                        className="me-2"
                        onClick={() => {
                            showModal("edit");
                            setSelectedRowData(record);
                        }} data-bs-toggle="tooltip"
                          data-bs-placement="top"
                            title="Edit"
                    >
                        <i className="ti ti-edit" />
                    </button>
                    <button
                        onClick={() => {
                            setSelectedRowData(record);
                            setIsDeleteModalVisible(true);
                        }} data-bs-toggle="tooltip"
                        data-bs-placement="top"
                         title="Delete"
                    >
                        <i className="ti ti-trash" />
                    </button>
                </div>
            ),
        },
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <PageHeader
                        title="Employee Mapping"
                        breadcrumbs={[
                            { label: <i className="ti ti-smart-home" />, path: all_routes.adminDashboard },
                            { label: "Accounting" },
                            { label: "Employee Mapping List", isActive: true },
                        ]}
                        // listViewPath={all_routes.clientlist}
                        listViewPath="#"
                        onExportCSV={() => exportToCSV(ExportData, 'PFEmployeeMappingData')}
                        onExportExcel={() => exportToExcel(ExportData, 'PFEmployeeMappingData')}
                        onExportPDF={() => exportToPDF(ExportData, 'PFEmployeeMappingData')}
                        onAdd={() => showModal('create')}
                        addLabel="Add Employee Mapping"
                        exportEnabled
                        addButtonEnabled
                        rightExtra={<CollapseHeader />}
                    />
                    {/* /Breadcrumb */}
                    <div className="card">
                        <StatusFilterHeader
                            title="Employee Mapping List"
                            selectedStatus={selectedStatus}
                            setSelectedStatus={setSelectedStatus}
                            selectedSort={selectedSort}
                            setSelectedSort={setSelectedSort}
                        />
                        <div className="card-body p-0">
                            <Table key={tableKey} dataSource={filtereddata} columns={columns} Selection={false} />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            <PfEmployeeMappingModal modalType={modalType} handleCancel={handleCancel} isModalVisible={isModalVisible} selectedRowData={selectedRowData} setTableKey={setTableKey} />
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.pfEmployeeId && handleDeletePfEmployee(selectedRowData.pfEmployeeId)}
            />
        </>
    );
};
export default PfEmployeeMapping;
